import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  FETCH_ALL_CAMPAIGNS,
} from '../actions/campaign/action_types';
import actions from '../actions/campaign';
import rf from '../../requests/RequestFactory';

function* fetchAllCampaign(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('CampaignRequest').fetchAllCampaigns(params), action.params);
    yield put(actions.fetchAllCampaignActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchAllCampaignActionFailed(err));
  }
}

function* watchAllCampaign() {
  yield takeLatest(FETCH_ALL_CAMPAIGNS, fetchAllCampaign);
}

export default function* rootSaga() {
  yield all([fork(watchAllCampaign)]);
}
